import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AddDriverComponent } from './add-driver/add-driver.component';
import { DriversComponent } from './drivers/drivers.component';
import { DriverInfoComponent } from './driver-info/driver-info.component';
import { DriverProfileComponent } from './driver-info/driver-profile/driver-profile.component';
import { DriverHistoryComponent } from './driver-info/driver-history/driver-history.component';
import { DriverFeedbackComponent } from './driver-info/driver-feedback/driver-feedback.component';


 const routes: Routes = [
  { path: '',      component: DriversComponent },
  { path: 'add-driver',      component: AddDriverComponent },
  { path: 'driverinfo/:Id', component: DriverInfoComponent,
  children: [
    {path: 'profile', component: DriverProfileComponent},
    {path: 'orders', component: DriverHistoryComponent},
    {path: 'driverFeedback', component: DriverFeedbackComponent}
  ]}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class DriverRoutingModule { }
